import React from 'react';
import './ReportModal.css';

const ReportModal = ({ isOpen, onClose, data }) => {
  if (!isOpen || !data) {
    return null;
  }

  const renderFinancials = (financials) => {
    const metrics = {
      'Total Revenue': financials.total_revenue,
      'Net Profit': financials.net_profit,
      'EBITDA': financials.ebitda,
      'EPS': financials.earnings_per_share_eps,
      'Debt/Equity': financials.debt_to_equity_ratio,
      'ROE': financials.return_on_equity_roe,
    };

    return Object.entries(metrics).map(([key, value]) => {
      if (!value) return null;
      return (
        <div key={key} className="metric-item">
          <span className="metric-label">{key}</span>
          <span className="metric-value">{value}</span>
        </div>
      );
    });
  };

  return (
    <div className="report-modal-overlay" onClick={onClose}>
      <div className="report-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="report-modal-header">
          <h2>{data.company_name || 'Unknown Company'} - {data.fiscal_year || 'Unknown Year'}</h2>
          <button onClick={onClose} className="close-button">×</button>
        </div>
        <div className="report-modal-body">
          <div className="summary-section card">
            <h3>Overall Summary</h3>
            <p>{data.overall_summary || 'No summary available'}</p>
          </div>

          <div className="report-grid">
            <div className="card">
              <h3>Key Metrics</h3>
              <div className="metrics-grid">
                {renderFinancials(data.financials)}
              </div>
            </div>

            <div className="card">
                <h3>Operational Highlights</h3>
                <ul className="highlights-list">
                    {data.operational_highlights?.key_achievements ? 
                        data.operational_highlights.key_achievements.split('\n- ').map((item, index) => item && <li key={index}>{item.replace(/^- /, '')}</li>) :
                        <li>No operational highlights available</li>
                    }
                </ul>
            </div>

            <div className="card">
              <h3>Pros</h3>
              <ul className="pros-cons-list">
                {data.pros_and_cons?.pros ? 
                  data.pros_and_cons.pros.map((pro, index) => (
                    <li key={index} className="pro-item">{pro}</li>
                  )) :
                  <li>No pros available</li>
                }
              </ul>
            </div>

            <div className="card">
              <h3>Cons / Risks</h3>
              <ul className="pros-cons-list">
                {data.pros_and_cons?.cons ? 
                  data.pros_and_cons.cons.map((con, index) => (
                    <li key={index} className="con-item">{con}</li>
                  )) :
                  <li>No cons/risks available</li>
                }
              </ul>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ReportModal;
